// components/product/CollapsibleDescription.tsx

'use client';

import { useState } from 'react';
import RTFContent from '@/components/RTFContent';

export default function CollapsibleDescription({ content }: { content: string }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="relative">
      <div
        className={`transition-all duration-300 ease-in-out overflow-hidden ${
          expanded ? 'max-h-[1000px]' : 'max-h-32'
        }`}
      >
        <RTFContent content={content} />
      </div>

      {!expanded && (
        <div className="relative">
          <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-white to-transparent pointer-events-none" />
        </div>
      )}

      <div className="text-left mt-2">
        <button
          className="text-primary underline text-sm"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? 'Weniger anzeigen' : 'Mehr anzeigen'}
        </button>
      </div>
    </div>
  );
}
